import { format } from 'date-fns';

import { EDateFormat } from 'detailsv2/structure';

export function getLocalDateFromString(date: string): Date {
  let day: number, month: number, year: number;

  if (date.includes('/')) {
    const parts = date.split('/');

    if (parts[2]?.length === 4) {
      if (parseInt(parts[0], 10) > 12) {
        [day, month, year] = parts.map(Number);
      } else {
        [month, day, year] = parts.map(Number);
      }
    } else {
      [year, month, day] = parts.map(Number);
    }
  } else if (date.includes('-')) {
    [year, month, day] = date.split('-').map(Number);
  } else {
    return new Date('Invalid Date');
  }

  return new Date(year, month - 1, day);
}

export const formatDatePickerValue = (v: string, dateFormat: EDateFormat) => {
  if (!v) return '';

  return format(getLocalDateFromString(v), dateFormat === EDateFormat.DMY ? 'dd/MM/yyyy' : 'MM/dd/yyyy');
};
